// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  adminMistake: (t, data?, options?) => t('enum.payment-override-reason.admin-mistake.name', data, options),
  fraudulentBehaviour: (t, data?, options?) => t('enum.payment-override-reason.fraudulent-behaviour.name', data, options),
  legacyCancellationWithNotice: (t, data?, options?) => t('enum.payment-override-reason.legacy-cancellation-with-notice.name', data, options),
  legacyCancellationWithoutNotice: (t, data?, options?) => t('enum.payment-override-reason.legacy-cancellation-without-notice.name', data, options),
  other: (t, data?, options?) => t('enum.payment-override-reason.other.name', data, options),
  ruleViolation: (t, data?, options?) => t('enum.payment-override-reason.rule-violation.name', data, options),
  studentIssue: (t, data?, options?) => t('enum.payment-override-reason.student-issue.name', data, options),
  systemIssue: (t, data?, options?) => t('enum.payment-override-reason.system-issue.name', data, options),
  teacherAbsence: (t, data?, options?) => t('enum.payment-override-reason.teacher-absence.name', data, options),
  teacherTechnicalIssue: (t, data?, options?) => t('enum.payment-override-reason.teacher-technical-issue.name', data, options),
  verifiedTeacherReason: (t, data?, options?) => t('enum.payment-override-reason.verified-teacher-reason.name', data, options),
  /* eslint-enable max-len */
};
